var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const Skeleton = (props) => {
    const { label, className, children } = props, rest = __rest(props, ["label", "className", "children"]);
    const BEM = () => {
        const classArray = ['skeleton'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", Object.assign({ className: BEM() }, rest),
        React.createElement("div", { className: "skeleton__content", "aria-hidden": true }, children),
        React.createElement("span", { className: "sr-only" }, label)));
};
export default Skeleton;
